<template>
  <div class="_feed" ref="caseFeed">
    <div class="_feed_item" v-for="(_item, index) in items" :key="index">
      <Note
        v-if="'note' == _item._type"
        :note="_item"
        :caseId="caseId"
        :userListItems="userListItems"
        :atNoteEdit="atNoteEdit"
        :atNewComment="newAddedComment && newAddedComment.length && newAddedComment[0].type == 'note' && newAddedComment[0].noteId == _item.id ? newAddedComment : []"
      />
      <Message
        v-if="'message' == _item._type"
        :message="_item"
        :caseId="caseId"
        :userListItems="userListItems"
        :atReply="atReply"
        :atShowAttachment="atShowAttachment"
        :manualCase="manualCase"
        :atNewComment="newAddedComment && newAddedComment.length && newAddedComment[0].type == 'message' && newAddedComment[0].messageId == _item.id ? newAddedComment : []"
      />
      <Comment
        v-if="'taskComment' == _item._type"
        :comment="_item"
        :commentId= _item.id
        :userListItems="userListItems"
        :type="_item._type"
        :caseId="caseId"
        :atNewComment="newAddedComment && newAddedComment.length && newAddedComment[0].type == 'comment'  && newAddedComment[0].parentCommentId == _item.id ? newAddedComment : []"
      />
      <Comment
        v-if="'serviceComment' == _item._type"
        :comment="_item"
        :commentId= _item.id
        :userListItems="userListItems"
        :type="_item._type"
        :serviceId="serviceId"
      />
      <Change
        v-if="'change' == _item._type"
        :item="_item"
      />
    </div>
  </div>
</template>

<script>
import Message from "@/components/DynamicForm/Message";
import Note from "@/components/DynamicForm/Note";
import Change from "@/components/DynamicForm/Change";
import Comment from "@/components/DynamicForm/Comment";

export default {
  components: {
    Message,
    Note,
    Change,
    Comment
  },
  props: {
    caseId: {
      type: String,
      required: true
    },
    serviceId: {
      type: String,
      required: false
    },
    items: {
      type: Array,
      required: true
    },
    userListItems: {
      type: Array,
      default: []
    },
    atReply: {
      type: Function,
      required: true
    },
    atNoteEdit: {
      type: Function,
      required: true
    },
    atShowAttachment: {
      type: Function,
      required: true
    },
    manualCase: {
      type: Boolean,
      required: true
    },
    newAddedComment: {
      type: Array
    },
  },
  mounted() {
    this.$refs.caseFeed.addEventListener('click', this.openLinksInNewTab);
  },
  beforeDestroy() {
    this.$refs.caseFeed.removeEventListener('click', this.openLinksInNewTab);
  },
  methods: {
    openLinksInNewTab(e) {
      if ('a' == e.target.tagName.toLowerCase()) {
        if(e.target.getAttribute('target') == '_self') {
          e.target.setAttribute('target', '_self');
        }
        else {
          e.target.setAttribute('target', '_blank');
        }    
      }
    }
  }
};
</script>

<style scoped>
</style>
